import React from 'react';
import Menu from './Menu.js';
import Foot from './Foot.js';
import Cover from './Cover.js';
import ProductItem from './ProductItem.js';
import '../Styles/Catalogue.css';


const Catalogue = ({posts}) => {

	const renderProducts = ()=> {

		// let firstTen = [];

		// for (let i = 0; i < 10; i++) {
		// 	firstTen.push(Products[i]);
		// }

		if (posts.length < 1) {
			
			return <div className="filler"></div>
			/*return <div className="filler">Oops, something went wrong :( <br/>Try again later</div>*/
		}

		return posts.map((product) => {
			
			return (
				<ProductItem
					key={product.id}
					item={product}
				/>
			)
		})
	}

	return (
		<div className="Catalogue-page">
			<header>
				<Menu id="Menu" className="row-container"/>
				<Cover id="Cover" className="column-container"/>
			</header>
			<main>				
				<div id="Catalogue" className="column-container">
					<div className="gallery">
						{renderProducts()}
					</div>
				</div>
			</main>
			<footer className="centered">
				<Foot/>
			</footer>
		</div>
	)
};

export default Catalogue;